/*
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-09-24 20:12:14
 */
import React, { useMemo } from 'react'
import { Tag } from 'antd'
import produce from 'immer'
import { TodayIconFont as IconFont } from '../../IconFonts'
import sensors from '../../../../utils/sensors'
import { useGroupID } from '../../../../app/hooks'
import { DepartmentMemberV2, DepartmentV2 } from '../../../../global'
import { CloseOutlined } from '@ant-design/icons'

interface IDepartment {
  department: DepartmentV2
  selectedDepartments: DepartmentV2[]
  setSelectedDepartments: (selectedDepartments: DepartmentV2[]) => void
}

const Department: React.FC<IDepartment> = (props) => {
  const { department, selectedDepartments, setSelectedDepartments } = props
  const groupID = useGroupID()
  return (
    <div className="selected-department" key={department.id}>
      <div className="department-name">
        <IconFont type="icondepartment" style={{ color: '#0093FF' }} />
        <span className="name">{department.name}</span>
      </div>
      <CloseOutlined
        style={{ cursor: 'pointer' }}
        onClick={() => {
          setSelectedDepartments(
            produce(selectedDepartments, (draft) => {
              draft.splice(
                draft.findIndex((item) => item.id === department.id),
                1
              )
            })
          )
          sensors.track('web_workgroup_filter_member_page_click', {
            clickItem: 'cancelOneDepartment',
            pagePath: window.location.pathname,
            groupID: groupID
          })
        }}
      />
    </div>
  )
}

interface IUser {
  user: DepartmentMemberV2
  removeUserFromSelectedUsers: (userID: string) => void
}

const User: React.FC<IUser> = (props) => {
  const { user, removeUserFromSelectedUsers } = props
  const groupID = useGroupID()
  return (
    <div className="selected-department" key={user.userID}>
      <div className="user-name">
        <img
          className="headimg"
          src={user.avatar + '?x-oss-process=image/resize,w_48'}
        />
        <span className="name">
          {user.quit && <Tag>已退出</Tag>}
          {user.name}
        </span>
      </div>
      <CloseOutlined
        style={{ cursor: 'pointer' }}
        onClick={() => {
          removeUserFromSelectedUsers(user.userID)
          sensors.track('web_workgroup_filter_member_page_click', {
            clickItem: 'cancelOneMember',
            memberStatus: user.quit ? 'offJob' : 'onJob',
            pagePath: window.location.pathname,
            groupID: groupID
          })
        }}
      />
    </div>
  )
}

interface ISelectedDepartments {
  selectedDepartments: DepartmentV2[]
  setSelectedDepartments: (selectedDepartments: DepartmentV2[]) => void
  selectedDepartmentUsers: DepartmentMemberV2[]
  removeUserFromSelectedUsers: (userID: string) => void
}

const SelectedDepartments: React.FC<ISelectedDepartments> = (props) => {
  const {
    selectedDepartments,
    setSelectedDepartments,
    selectedDepartmentUsers,
    removeUserFromSelectedUsers
  } = props

  const departments = useMemo(() => {
    return selectedDepartments.map((department) => (
      <Department
        key={department.id}
        department={department}
        selectedDepartments={selectedDepartments}
        setSelectedDepartments={setSelectedDepartments}
      />
    ))
  }, [selectedDepartments])

  const users = useMemo(
    () =>
      selectedDepartmentUsers.map((user) => (
        <User
          key={user.userID}
          user={user}
          removeUserFromSelectedUsers={removeUserFromSelectedUsers}
        />
      )),
    [selectedDepartmentUsers]
  )

  return (
    <>
      {departments}
      {users}
    </>
  )
}

export default SelectedDepartments
